import { DatePipe } from '@angular/common';
import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { Store } from '@ngrx/store';
import { Configuration } from 'app/app.configuration';
import { DateConvertor } from 'app/shared/common/helper/dateConvertor';
import { GetReportingToService } from 'app/shared/common/helper/get-reporting-to';
import { DataService } from 'app/shared/common/helper/http-service';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { AppState } from 'app/store/models/app-state.model';
import { CountryItem } from 'app/store/models/countryItem.model';
import Highcharts from 'highcharts';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-interview-info',
  templateUrl: './interview-info.component.html',
  styleUrls: ['./interview-info.component.scss'],
  providers: [DatePipe]
})
export class InterviewInfoComponent implements OnInit {


  /** Interview Metrics chart info start **/

  totalInterviewScheduled: any = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  totalInterviewSelected: any = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  totalInterviewPending: any = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  totalInterviewRejected: any = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

  highcharts = Highcharts;


  /** Interview Metrics chart info end **/

  firstname: string = '';
  lastname: string = '';
  totalRecords: number = 0;
  first: number = 0;
  rowData: any[] = [];
  empRole: any = '';
  interviewDetailsForm!: FormGroup;
  tenantId: string = '';
  employeesList: any[] = [];
  techStack: Array<string> = [];
  interviewStatus: Array<string> = ["Selected", "Rejected"];
  interviewStatusType: any[] = [{ label: "Selected", value: "Selected" }, { label: "Rejected", value: "Rejected" }, { label: "Pending", value: "Pending" }];
  ratingList: Array<number> = [1, 2, 3, 4, 5];
  experiencesList: Array<number> = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  interviewTitle: string = 'Create';
  interviewUpdateId: string = '';
  deleteInterviewId: string = '';
  myEndDate = new Date();
  reportingToOptions: any[];
  profileId = this.parseService.instance.User.current().get('profile').id;
  interviewTypeName: string = "Client";
  interviewItems$: Observable<Array<CountryItem>>;
  urlList: Array<string> = [];
  urlTableShow: boolean = false;
  isShowNextButton: boolean = true;
  totalInterviewInfo: any = [];
  copyEmployeeInfo: any[] = [];
  totalClientRecords: number = 0;
  selectReporting: any;
  isShowMetricsView: boolean = false;

  @ViewChild('interview', { static: true }) interviewInfoDialog: TemplateRef<any>;
  @ViewChild('confirmPopup', { static: true }) confirmPopup: TemplateRef<any>;

  cols: any = [
    { field: 'position', header: 'S.No' },
    { field: 'profileImageInfo', header: 'Profile' },
    { field: 'userName', header: 'Name' },
    { field: 'reportingTo', header: 'Reporting To' },
    { field: 'createdBy', header: 'Created By' },
    { field: 'interviewType', header: 'Type' },
    { field: 'interviewDate', header: 'Date' },
    { field: 'techStack', header: 'Tech Stack' },
    { field: 'rating', header: 'Rating' },
    { field: 'interviewStatus', header: 'Status' },
    { field: 'action', header: 'Action' }
  ];
  chartOptions: {
    chart: { type: string; }; title: { text: string; color: string; };
    //  subtitle: {
    //     text: "Source: WorldClimate.com"
    //  },
    xAxis: { categories: string[]; }; yAxis: { title: { text: string; color: string; }; }; tooltip: { valueSuffix: string; }; series: { name: string; data: any; }[]; colors: string[];
  };
  annualTotalInterview: number = 0;
  annualSelectedInterview: number = 0;
  annualPendingInterview: number = 0;
  annualRejectedInterview: number = 0;

  constructor(
    private parseService: ParseService,
    private storageConfiguration: StorageConfiguration,
    private dialog: MatDialog,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private datePipe: DatePipe,
    private dateConvertor: DateConvertor,
    private getReportingToService: GetReportingToService,
    private spinner: NgxSpinnerService,
    private store: Store<AppState>,
    private dataService: DataService,
    private configuration: Configuration,
  ) {
    this.firstname = this.parseService.instance.User.current().get('firstName');
    this.lastname = this.parseService.instance.User.current().get('lastName');
    this.empRole = this.storageConfiguration.sessionGetItem(this.storageConfiguration.role);
    this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
  }

  ngOnInit() {
    this.interviewFrom();
    this.getEmployees();
    this.getTechStack();
    this.getReportingTo();
    this.getInterviewInfo('Client');
    this.update();
  }

  // Interview form validate
  interviewFrom() {
    this.interviewDetailsForm = this.fb.group({
      name: ["", Validators.required],
      interviewType: ["", Validators.required],
      interviewDate: [new Date(), Validators.required],
      jd: ["", Validators.required],
      rating: [null],
      status: [''],
      exp: [null, Validators.required],
      techStack: [Validators.required],
      command: [''],
      url: ['', [Validators.pattern('(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?')]],
      coding: [false],
      communication: [false],
      technical: [false],
      project: [false]
    });
  }

  getEmployees() {
    let queryInstance = this.parseService.instance.Object.extend('Profile');
    let query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('tenantId', this.tenantId);
    query.equalTo('isActive', true);
    query.limit(1000);
    query.equalTo('isLongLeave', false);
    query.find().then(result => {
      if (result.length > 0) {
        this.employeesList = [];
        for (let data of result) {
          this.employeesList.push({
            id: data.id,
            name: data.get('username'),
            reportingId: data.get('reportingTo').id
          })
        }

        this.copyEmployeeInfo = this.employeesList;
      } else {
        this.employeesList = [];
        this.copyEmployeeInfo = [];
      }
    });
  }

  getTechStack() {
    let queryInstance = this.parseService.instance.Object.extend('DataSettings');
    let query = new this.parseService.instance.Query(queryInstance);
    query.find().then(result => {
      if (result.length > 0) {
        this.techStack = [];
        this.techStack = result[0].get('skill_set');
      } else {
        this.techStack = [];
      }
    });
  }

  getInterviewInfo(event?: any, reportingToFilter?: any, statusToFilter?: any) {
    this.spinner.show();
    let interviewInfo = event.index == 0 ? 'Client' : event.index == 1 ? 'Internal' : event ? event : 'Client';
    this.interviewTypeName = interviewInfo;
    this.rowData = [];
    this.totalClientRecords = 0;
    let queryInstance = this.parseService.instance.Object.extend('InterviewInfo');
    let query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('tenantId', this.tenantId);
    query.include('profile');
    if (reportingToFilter) { query.containedIn('reportingTo', reportingToFilter) }
    if (statusToFilter) { query.containedIn('status', statusToFilter) }
    if (this.empRole == 'Leader') { query.equalTo('reportingTo', { __type: 'Pointer', className: 'Profile', objectId: this.parseService.instance.User.current().get('profile').id }); }
    query.equalTo('isActive', true);
    query.equalTo('interviewType', interviewInfo);
    query.include('profile.reportingTo');
    query.descending('date');
    query.withCount();
    query.find().then(async result => {
      this.totalClientRecords = result.count;
      if (result.results.length > 0) {
        let i = 0;
        for (let data of result.results) {
          if (data.get('profile').get('reportingTo').id === this.parseService.instance.User.current().get('profile').id && this.empRole == 'Leader') {
            i = i + 1;
            await this.interviewInfoForm(data, i);
          }
          else if (this.empRole == 'Admin' || this.empRole == 'System Admin' || this.empRole == 'HR' || this.empRole == 'CEO') {
            i = i + 1;
            await this.interviewInfoForm(data, i);
          }
        }
      }
      this.spinner.hide();
    }).catch(error => {
      this.spinner.hide();
    })
  }

  interviewInfoForm(data, i) {
    let interviewInfo = {
      position: i,
      id: data.id,
      profileImageInfo: data.get('profile').get('profileImageInfo').url ? data.get('profile').get('profileImageInfo').url : '',
      userName: data.get('profile').get('username'),
      profileId: data.get('profile').id,
      reportingTo: data.get('profile').get('reportingTo').get('username'),
      interviewType: data.get('interviewType'),
      interviewDate: this.datePipe.transform(data.get('scheduledDate'), 'MM/dd/yyyy'),
      rating: data.get('rating'),
      interviewStatus: data.get('status'),
      jobDescription: data.get('jobDescription'),
      command: data.get('command'),
      techStack: data.get('techStack'),
      exp: data.get('experiences'),
      url: data.get('url'),
      internalType: data.get('internalType'),
      createdBy: data.get('createdBy').get('username')
    };
    this.rowData.push(interviewInfo);
  }

  createInterviewInfo() {
    this.interviewTitle = 'Create';
    this.urlTableShow = false;
    this.interviewFrom();
    this.dialog.open(this.interviewInfoDialog, {
      width: '670px',
      disableClose: true,
    });
  }

  saveInterviewDetails() {
    this.spinner.show();
    if (this.interviewDetailsForm.invalid) {
      this.spinner.hide();
      return this.toastr.warning("Please enter required field!!");
    }
    else {

      let internalType = [{ name: 'coding', isChecked: this.interviewDetailsForm.value.coding ? this.interviewDetailsForm.value.coding : false }, { name: 'communication', isChecked: this.interviewDetailsForm.value.communication ? this.interviewDetailsForm.value.communication : false },
      { name: 'technical', isChecked: this.interviewDetailsForm.value.technical ? this.interviewDetailsForm.value.technical : false }, { name: 'project', isChecked: this.interviewDetailsForm.value.project ? this.interviewDetailsForm.value.project : false }];

      let interviewInfo = this.interviewDetailsForm.value;
      const InterviewInfo = this.parseService.instance.Object.extend('InterviewInfo');
      const saveInterviewInfo = new InterviewInfo();
      saveInterviewInfo.set('tenantId', this.tenantId);
      saveInterviewInfo.set('jobDescription', interviewInfo.jd ? interviewInfo.jd : '');
      saveInterviewInfo.set('scheduledDate', this.dateConvertor.addGMTOffset(new Date(interviewInfo.interviewDate)).toISOString());
      saveInterviewInfo.set('interviewType', interviewInfo.interviewType);
      saveInterviewInfo.set('command', interviewInfo.command);
      saveInterviewInfo.set('status', interviewInfo.status ? interviewInfo.status : "Pending");
      saveInterviewInfo.set('rating', interviewInfo.rating ? interviewInfo.rating : 0);
      saveInterviewInfo.set('techStack', interviewInfo.techStack);
      saveInterviewInfo.set('isActive', true);
      saveInterviewInfo.set('date', new Date(this.dateConvertor.addGMTOffset(new Date(interviewInfo.interviewDate)).toISOString()));
      saveInterviewInfo.set('url', []);
      saveInterviewInfo.set('experiences', interviewInfo.exp);
      saveInterviewInfo.set('internalType', internalType);
      saveInterviewInfo.set('createdBy', { __type: 'Pointer', className: 'Profile', objectId: this.profileId });
      saveInterviewInfo.set('profile', { __type: 'Pointer', className: 'Profile', objectId: interviewInfo.name });
      saveInterviewInfo.save().then(() => {
        this.interviewDetailsForm.reset();
        this.dialog.closeAll();
        this.getInterviewInfo(this.interviewTypeName);
        this.spinner.hide();
        this.toastr.success("Created Successfully!!");
      }).catch(error => {
        this.interviewDetailsForm.reset();
        this.dialog.closeAll();
        this.spinner.hide();
        this.toastr.error("Something went wrong!!");
      });
    }
  }

  viewProfile(interviewInfo: any) {
    this.interviewTitle = 'Update';
    this.dialog.open(this.interviewInfoDialog, {
      width: '670px',
      disableClose: true,
    });

    let interviewTypeInfo = interviewInfo.internalType;
    let coding = interviewTypeInfo.find(x => x.name == 'coding');
    let communication = interviewTypeInfo.find(x => x.name == 'communication');
    let technical = interviewTypeInfo.find(x => x.name == 'technical');
    let project = interviewTypeInfo.find(x => x.name == 'project');

    this.getEmployees();
    this.urlList = [];
    this.interviewUpdateId = interviewInfo.id;
    this.interviewDetailsForm.patchValue({
      name: interviewInfo.profileId,
      interviewType: interviewInfo.interviewType,
      interviewDate: new Date(interviewInfo.interviewDate),
      jd: interviewInfo.jobDescription,
      rating: interviewInfo.rating,
      status: interviewInfo.interviewStatus,
      command: interviewInfo.command,
      techStack: interviewInfo.techStack,
      exp: interviewInfo.exp,
      coding: coding.isChecked,
      communication: communication.isChecked,
      technical: technical.isChecked,
      project: project.isChecked
    });

    if (interviewInfo.url.length > 0) {
      this.urlList = interviewInfo.url;
      this.urlTableShow = true;
    }
    else {
      this.urlTableShow = false;
    }

  }

  updateInterviewDetails() {
    let internalType = [{ name: 'coding', isChecked: this.interviewDetailsForm.value.coding ? this.interviewDetailsForm.value.coding : false }, { name: 'communication', isChecked: this.interviewDetailsForm.value.communication ? this.interviewDetailsForm.value.communication : false },
    { name: 'technical', isChecked: this.interviewDetailsForm.value.technical ? this.interviewDetailsForm.value.technical : false }, { name: 'project', isChecked: this.interviewDetailsForm.value.project ? this.interviewDetailsForm.value.project : false }];
    let interviewInfo = this.interviewDetailsForm.value;
    let queryInstance = this.parseService.instance.Object.extend('InterviewInfo');
    let query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('objectId', this.interviewUpdateId);
    query.find().then(result => {
      let interviewUpdate = result[0];
      interviewUpdate.set('tenantId', this.tenantId);
      interviewUpdate.set('jobDescription', interviewInfo.jd);
      interviewUpdate.set('scheduledDate', this.dateConvertor.addGMTOffset(new Date(interviewInfo.interviewDate)).toISOString());
      interviewUpdate.set('interviewType', interviewInfo.interviewType);
      interviewUpdate.set('command', interviewInfo.command);
      interviewUpdate.set('status', interviewInfo.status);
      interviewUpdate.set('rating', interviewInfo.rating);
      interviewUpdate.set('isActive', true);
      interviewUpdate.set('experiences', interviewInfo.exp);
      interviewUpdate.set('url', this.urlList);
      interviewUpdate.set('internalType', internalType);
      interviewUpdate.set('profile', { __type: 'Pointer', className: 'Profile', objectId: interviewInfo.name });
      interviewUpdate.save().then(result => {
        this.interviewDetailsForm.reset();
        this.dialog.closeAll();
        this.getInterviewInfo(this.interviewTypeName);
        this.toastr.success("Updated successfully!!");
      }).catch(error => {
        this.interviewDetailsForm.reset();
        this.dialog.closeAll();
        this.toastr.error("Something went wrong!!")
      });
    });
  }

  closePopup() {
    this.interviewDetailsForm.reset();
    this.dialog.closeAll();
    this.interviewUpdateId = '';
  }

  deleteConfirmPopup(id: string) {
    this.deleteInterviewId = id;
    this.dialog.open(this.confirmPopup);
  }

  deleteInterviewInfo() {
    let queryInstance = this.parseService.instance.Object.extend('InterviewInfo');
    let query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('objectId', this.deleteInterviewId);
    query.find().then(result => {
      let interviewUpdate = result[0];
      interviewUpdate.set('isActive', false);
      interviewUpdate.save().then(result => {
        this.toastr.success("Deleted successfully!!");
        this.dialog.closeAll();
        this.getInterviewInfo(this.interviewTypeName);
      });
    });
  }

  async getReportingTo() {
    await this.getReportingToService.getReportingTo().then(res => {
      this.reportingToOptions = res;
    });
  }

  addUrl() {
    if (this.interviewDetailsForm.value.url == '' || this.interviewDetailsForm.invalid) return this.toastr.warning("Pleas enter the validate link");
    else {
      this.urlTableShow = true;
      this.urlList.push(this.interviewDetailsForm.value.url);
      this.interviewDetailsForm.controls['url'].setValue('');
    }
  }

  deleteUrl(index: any) {
    this.urlTableShow = true;
    this.urlList.splice(index, 1);
    if (this.urlList.length == 0) this.urlTableShow = false;
  }

  sendEmail(id: string) {
    this.spinner.show();
    this.dataService.add(this.configuration.sendInterviewEmail, { id: id }).subscribe((data: any) => {
      this.toastr.success('Email Send successfully');
      this.spinner.hide();
    }, error => {
      this.toastr.warning('Unable to Send Email');
      console.log('error', error);
      this.spinner.hide();
    });
  }

  searchEmployee(event: any) {
    if (event.length > 0) {
      let inputValue = event.toLowerCase();
      this.employeesList = this.employeesList.filter(x => x.name.toLowerCase().includes(inputValue));
    }
    else {
      this.employeesList = this.copyEmployeeInfo;
    }
  }

  update() {
    let queryInstance = this.parseService.instance.Object.extend('InterviewInfo');
    let query = new this.parseService.instance.Query(queryInstance);
    query.include('profile.reportingTo');
    query.find().then(result => {

      for (let res of result) {

        res.set('reportingTo', { __type: 'Pointer', className: 'Profile', objectId: res.get('profile').get('reportingTo').id });
        res.save();
      }
    })
  }

  reportingTo(event: any) {
    if (event.value.length > 0) {
      this.getInterviewInfo(this.interviewTypeName, event.value);
    }
    else {
      this.getInterviewInfo(this.interviewTypeName);
    }
  }

  interviewStatusFilter(event: any) {
    if (event.value.length > 0) {
      this.getInterviewInfo(this.interviewTypeName, undefined, event.value);
    }
    else {
      this.getInterviewInfo(this.interviewTypeName);
    }
  }

  getInterviewMetrics() {

    this.spinner.show();

    this.totalInterviewScheduled = [];
    this.totalInterviewSelected = [];
    this.totalInterviewPending = [];
    this.totalInterviewRejected = [];
    const initialValue = 0;

    let queryInstance = this.parseService.instance.Object.extend('interviewLogs');
    let query = new this.parseService.instance.Query(queryInstance);
    query.ascending('currentMonth');
    query.equalTo('year', String(new Date().getFullYear()));
    query.find().then(result => {
      if (result.length > 0) {
        for (let data of result) {
          this.totalInterviewScheduled.push(data.get('totalInterviewPerMonth'));
          this.totalInterviewSelected.push(data.get('selectedCount'));
          this.totalInterviewPending.push(data.get('pendingCount'));
          this.totalInterviewRejected.push(data.get('rejectedCount'));
        }
        this.interviewMetrics();
        this.annualTotalInterview = this.totalInterviewScheduled.reduce((accumulator, currentValue) => accumulator + currentValue, initialValue);
        this.annualSelectedInterview = this.totalInterviewSelected.reduce((accumulator, currentValue) => accumulator + currentValue, initialValue);
        this.annualPendingInterview = this.totalInterviewPending.reduce((accumulator, currentValue) => accumulator + currentValue, initialValue);
        this.annualRejectedInterview = this.totalInterviewRejected.reduce((accumulator, currentValue) => accumulator + currentValue, initialValue);
        this.spinner.hide();
      }
      else {
        this.spinner.hide();
        this.totalInterviewScheduled = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        this.totalInterviewSelected = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        this.totalInterviewPending = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        this.totalInterviewRejected = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      }
    }).catch(error => {
      this.spinner.hide();
    })
  }


  interviewMetrics() {
    this.chartOptions = {
      chart: {
        type: "column"
      },
      title: {
        text: `Yearly Client Interview Metrics (${new Date().getFullYear()}) `,
        color: '#2C3460'
      },
      //  subtitle: {
      //     text: "Source: WorldClimate.com"
      //  },
      xAxis: {
        categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
          "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
      },
      yAxis: {
        title: {
          text: "Interview Log",
          color: '#2C3460'
        }
      },
      tooltip: {
        valueSuffix: " "
      },
      series: [{
        name: 'Total',
        data: this.totalInterviewScheduled
      }, {
        name: 'Selected',
        data: this.totalInterviewSelected
      }, {
        name: 'Pending',
        data: this.totalInterviewPending
      }, {
        name: 'Rejected',
        data: this.totalInterviewRejected
      }],

      colors: ['#0C8CE9', '#3EB645E3', '#FFA500', '#FF8181', '#2c3460'],
      // dullcolor
      // colors: ['#BCE3FF', '#C8F2C1', '#F5ECB5', '#FFA9A9', '#2c3460'],
    };
  }

  searchName(event) {
    if (event != '') {
      let inputValue = event.toLowerCase();
      this.rowData = this.rowData.filter(x => x.userName.toLowerCase().includes(inputValue));
    }
    else {
      this.getInterviewInfo(this.interviewTypeName);
    }
  }

}
